import * as z from "zod";

import {
  partnerApiTokenSchema,
  partnerIdSchema,
  partnerStoreSchema,
  partnerSummarySchema,
  partnerUserSchema,
} from "./shared";

export const getPartner = {
  name: "getPartner" as const,
  input: z.object({ partnerId: partnerIdSchema }),
  output: z.object({
    partner: partnerSummarySchema,
    users: z.array(partnerUserSchema),
    stores: z.array(partnerStoreSchema),
    apiTokens: z.array(partnerApiTokenSchema),
  }),
};
